import dayjs, { Dayjs } from "dayjs"
import {
  IReading,
  ReadingSequenceType,
  ReadingSource,
} from "./meterReading.types"
import { Status } from "@/types/Status"

export class Reading implements IReading {
  constructor(
    public id: number,
    public source: ReadingSource,
    public cumulative: number,
    public date: Dayjs,
    public unit: string,
    public sequenceType: ReadingSequenceType,
    public quality: string,
    public consumption: number,
    public statusCode: string,
    public rateName?: string,
    public meterIdentifier?: string,
  ) {}

  get isSmartReading() {
    return this.source === ReadingSource.Smart
  }

  get isSystemReading() {
    return this.source === ReadingSource.System
  }

  get isCustomerReading() {
    return this.source === ReadingSource.Customer
  }

  get isManualReading() {
    return this.source === ReadingSource.Manual
  }

  get isEstimated() {
    return this.quality?.toLowerCase() === "estimated"
  }

  get isOfTypeFirst() {
    return this.sequenceType === ReadingSequenceType.First
  }

  get dateStatus(): Status {
    const daysFromTodayFormatted = dayjs().diff(this.date, "day")
    const daysFromTodayFormattedStr = daysFromTodayFormatted
      ? `${daysFromTodayFormatted} Days`
      : "Today"

    switch (true) {
      case daysFromTodayFormatted >= (this.isSmartReading ? 60 : 180):
        return new Status("critical", daysFromTodayFormattedStr)
      case daysFromTodayFormatted >= (this.isSmartReading ? 30 : 90):
        return new Status("caution", daysFromTodayFormattedStr)
      default:
        return new Status("normal", daysFromTodayFormattedStr)
    }
  }

  get status(): Status {
    // The backoffice reading status arrives upper-cased (e.g. ACCEPTED) where
    // Ark sent Accepted; match case-insensitively and keep the old labels.
    switch (this.statusCode?.toLowerCase()) {
      case "accepted":
        return new Status("normal", "Accepted")
      case "pending":
        return new Status("critical", "Pending")
      default:
        return new Status("caution", this.statusCode)
    }
  }

  get kwhConversionFactor() {
    const m3ToKWHConversion = (1.02264 * 39.2) / 3.6
    if (this.unit == "m3") {
      return m3ToKWHConversion
    } else if (this.unit == "hcf") {
      return m3ToKWHConversion * 2.83
    } else {
      return 1
    }
  }
}
